import * as React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
const neighborhoods = ["Downtown Sacramento", "Midtown", "East Sacramento", "Natomas", "Elk Grove", "Roseville", "Folsom", "Citrus Heights", "Carmichael", "Rancho Cordova", "West Sacramento", "Arden-Arcade"];
export default function ServiceAreaMap() {
  return <section id="service-area-map" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        {}
        <div className="text-center mb-12 md:mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight mb-4">
            Serving All of Sacramento & Surrounding Areas
          </h2>
          <p className="text-lg text-muted-foreground">
            Fast, reliable, and professional home renewal services right in your neighborhood.
          </p>
        </div>

        {}
        <div className="border border-secondary/20 rounded-2xl overflow-hidden bg-card shadow-sm grid grid-cols-1 lg:grid-cols-2">
          
          {}
          <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center">
            <h3 className="text-2xl font-default font-semibold mb-8 text-foreground">
              Our Primary Service Areas
            </h3>
            
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 mb-10">
              {neighborhoods.map((area, i) => <li key={i} data-index={i} className="flex items-center gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                    <Check className="w-4 h-4" />
                  </span>
                  <span className="text-muted-foreground font-medium">{area}</span>
                </li>)}
            </ul>

            <div className="mt-auto pt-8 border-t border-border/50">
              <p className="text-sm text-muted-foreground mb-4">
                Don't see your specific area listed? We likely still cover it! Contact us to confirm availability for your project.
              </p>
              <Button size="lg" className="w-full sm:w-auto">
                Check Availability
              </Button>
            </div>
          </div>

          {}
          <div className="relative min-h-[300px] sm:min-h-[400px] lg:min-h-full bg-muted">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623242/img/sacramento_service_area_map_styled.png" alt="Map showing service areas in Sacramento, California" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            {}
            <div className="absolute inset-0 bg-secondary/5 mix-blend-multiply pointer-events-none"></div>
          </div>

        </div>
      </div>
    </section>;
}